import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementShiftStatsResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setShiftStats } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useRotaShiftStatsAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    // dispatch(
    //   setLoading({
    //     key: "isOrgServicesInProgress",
    //     status: true,
    //   })
    // );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(ROTA_APIS?.ROTA_SHIFT_STATS_LIST?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IRotaManagementShiftStatsResponse>) => {
          if (res.data.status === true) {
            dispatch(setShiftStats({ data: res.data.data }));
          } else {
            //
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            toast.error("Error while fetching Shift Stats");
          }
          if (e.status === 400) {
            toast("Services records not found");
          }
          if (e.response.status === 500) {
            toast.error("Server error 500");
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
